import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslationCoreModule } from '@qtek/libs/translation-core';

export interface ExtractionOptInDialogData {
  /** Shown so the user knows which upload this is about during a busy session. */
  fileName?: string;
}

export const extractionOptInDialogConfig: MatDialogConfig = {
  autoFocus: false,
  width: '520px',
};

/**
 * SD-2665 — asks whether to extract a data-room document that classified as a
 * term sheet or credit agreement.
 *
 * <p>Data-room uploads deliberately skip extraction (SD-2668): banks routinely
 * file superseded documents just to house them, and extracting every one costs
 * real money. Accepting calls the backend trigger; declining leaves the document
 * stored with nothing extracted.
 *
 * <p>The copy deliberately mentions covenants as well as fields — declining also
 * suppresses covenant extraction, so wording it as only a deal-site update would
 * quietly cost the user rows they would otherwise get.
 */
@Component({
  selector: 'qt-extraction-opt-in-dialog',
  templateUrl: './extraction-opt-in-dialog.component.html',
  styleUrls: ['./extraction-opt-in-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslationCoreModule,
  ],
})
export class ExtractionOptInDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<ExtractionOptInDialogComponent, boolean>>(MatDialogRef);
  private readonly data = inject<ExtractionOptInDialogData>(MAT_DIALOG_DATA, {
    optional: true,
  });

  readonly fileName = this.data?.fileName ?? '';

  accept(): void {
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }
}
